export const rootPaths = {
    root: 'app/',
    errorsRoot: 'app/errors',
}

export default {
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,

  compilaQuestionarioAmbito: (ambitoCsvcCodice) =>
    `/app/questionario/compila-ambito${ambitoCsvcCodice ? `/${ambitoCsvcCodice}` : ''
    }`,
}
